var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM13.667 13.4204C13.889 12.9959 14 12.5404 14 12.0538C14 11.3187 13.7509 10.682 13.2528 10.1436C12.7601 9.60011 11.9777 9.11869 10.9056 8.69939C10.4129 8.50786 10.0555 8.32668 9.8335 8.15585C9.61692 7.97985 9.50863 7.76761 9.50863 7.51913C9.50863 7.31725 9.60068 7.1516 9.78477 7.02219C9.96887 6.88759 10.2098 6.8203 10.5076 6.8203C11.0058 6.8203 11.512 6.89536 12.0264 7.04548C12.5462 7.1956 13.0146 7.3949 13.4315 7.64337V4.81697C12.8467 4.63579 12.0751 4.51932 11.1168 4.46755V3H9.19188V4.5452C8.1956 4.71603 7.4132 5.09133 6.84467 5.6711C6.28156 6.25088 6 6.96783 6 7.82196C6 9.29211 6.87445 10.3585 8.62335 11.0211C9.089 11.1971 9.43824 11.3472 9.67107 11.4714C9.90931 11.5957 10.0799 11.7173 10.1827 11.8364C10.2856 11.9503 10.3371 12.1056 10.3371 12.3023C10.3371 12.5352 10.2531 12.719 10.0853 12.8536C9.92284 12.9882 9.69814 13.0555 9.41117 13.0555C8.35533 13.0555 7.267 12.662 6.14619 11.8752V14.787C6.33029 14.9371 6.73096 15.0795 7.34822 15.2141C7.9709 15.3435 8.58545 15.4134 9.19188 15.4237V17H11.1168V15.2141C11.734 15.064 12.2565 14.8336 12.6843 14.523C13.1174 14.2072 13.445 13.8397 13.667 13.4204Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeals);
export default __webpack_public_path__ + "static/media/deals.4c004ca0a793afca02f95dcf4a834c3b.svg";
export { ForwardRef as ReactComponent };